import {ColDef, ICellRendererParams} from "ag-grid-community";
import {t} from "i18next";
import React, {ReactNode} from "react";
import {GreenDiscountEntityResponse} from "../../../api/types/greenDiscount";
import {dateFormatter} from "../../../utils";

export const GreenDiscountColDef = ({
                                        actionsRenderer,
                                        actionColDef,
                                        user
                                    }: {
    actionsRenderer: (params: ICellRendererParams) => ReactNode;
    actionColDef: ColDef;
    user: any
}): ColDef<GreenDiscountEntityResponse>[] => [
    {
        field: "legalEntities",
        headerName: t("pricing:peaks.table.headers.legalEntities"),
        headerTooltip: t("pricing:peaks.table.headers.legalEntities"),
        editable: false,
        flex: 1,
        filter: "text",
        cellRenderer: (params: ICellRendererParams) => t('translation:legalEntities.'.concat(params.data.legalEntity)),
        hide: user.legalEntities.length === 1 && user.dealers.length === 1 ? true : false
    },
    {
        field: "dealers",
        headerName: t("pricing:peaks.table.headers.dealers"),
        headerTooltip: t("pricing:peaks.table.headers.dealers"),
        editable: false,
        flex: 1,
        filter: "text",
        cellRenderer: (params: ICellRendererParams) => t('translation:dealers.'.concat(params.data.dealer)),
        hide: user.legalEntities.length === 1 && user.dealers.length === 1 ? true : false
    },
    {
        headerName: t("pricing:upsellingRate.table.headers.name"),
        headerTooltip: t("pricing:upsellingRate.table.headers.name"),
        field: "name",
        sortable: true,
        flex: 1,
        filter: "text"
    },
    {
        field: "showOnlyActive",
        hide: true,
        filter: "text"
    },
    {
        headerName: t("pricing:upsellingRate.form.labels.commercialSegment"),
        headerTooltip: t("pricing:upsellingRate.form.labels.commercialSegment"),
        field: "commercialSegmentId",
        cellRenderer: (params: ICellRendererParams) => params.data.commercialCategory?.commercialSegment.name,
        flex: 1,
        sortable: false,
        filter: "text"
    },
    {
        headerName: t("pricing:upsellingRate.table.headers.commercialCategory"),
        headerTooltip: t("pricing:upsellingRate.table.headers.commercialCategory"),
        field: "commercialCategoryId",
        cellRenderer: (params: ICellRendererParams) => {
            const category = params.data?.commercialCategory;
            const legalEntity = params.data?.legalEntity;
            
            if (!category) {
                return '';
            }
            
            if (!category.labels || category.labels.length === 0) {
                return category.name || '';
            }
            
            const labelObj = category.labels.find((l: any) => l.country === legalEntity);
            return labelObj?.label || category.name || '';
        },
        flex: 1,
        sortable: true,
        filter: "text"
    },
    {
        headerName: `${t("pricing:ancillary.form.labels.reservationFrom")}`,
        headerTooltip: `${t("pricing:ancillary.form.labels.reservationFrom")}`,
        field: "reservationFrom",
        valueFormatter: (params) => params.data?.reservationFrom ? dateFormatter(params.data?.reservationFrom) : "",
        flex: 1,
        sortable: true,
        filter: "text"
    },
    {
        headerName: `${t("pricing:ancillary.form.labels.reservationTo")}`,
        headerTooltip: `${t("pricing:ancillary.form.labels.reservationTo")}`,
        field: "reservationTo",
        valueFormatter: (params) => params.data?.reservationTo ? dateFormatter(params.data?.reservationTo) : "",
        flex: 1,
        sortable: true,
        filter: "text"
    },
    {
        headerName: `${t("pricing:ancillary.form.labels.pickupDateFrom")}`,
        headerTooltip: `${t("pricing:ancillary.form.labels.pickupDateFrom")}`,
        field: "pickupFrom",
        valueFormatter: (params) => params.data?.pickupFrom ? dateFormatter(params.data?.pickupFrom) : "",
        flex: 1,
        sortable: true,
        filter: "text"
    },
    {
        headerName: `${t("pricing:ancillary.form.labels.pickupDateTo")}`,
        headerTooltip: `${t("pricing:ancillary.form.labels.pickupDateTo")}`,
        field: "pickupTo",
        valueFormatter: (params) => params.data?.pickupTo ? dateFormatter(params.data?.pickupTo) : "",
        flex: 1,
        sortable: true,
        filter: "text"
    },
    {
        ...actionColDef,
        cellRenderer: actionsRenderer
    }
];
